export enum IntegrationPartnerEnum {
  CoinGecko = 1,
  Moralis = 2,
  Helius = 3,
  Zerion = 4
}

export const IntegrationPartnerLabel: Record<IntegrationPartnerEnum, string> = {
  [IntegrationPartnerEnum.CoinGecko]: 'CoinGecko',
  [IntegrationPartnerEnum.Moralis]: 'Moralis (EVM)',
  [IntegrationPartnerEnum.Helius]: 'Helius (Solana)',
  [IntegrationPartnerEnum.Zerion]: 'Zerion (Multi-chain)'
};
